/**
 * Wizard Layout hooks
 * 
 * Extracted from WizardDataProvider.tsx to avoid react-refresh warnings.
 */

import React, { useContext } from 'react';
import { WizardDataContext, WizardDataProvider, type WizardDataContextValue } from './WizardDataProvider';

/**
 * Hook to access wizard data context
 * Must be used within a WizardDataProvider
 */
export const useWizardData = <TData = Record<string, unknown>>(): WizardDataContextValue<TData> => {
  const context = useContext(WizardDataContext);
  if (!context) {
    throw new Error('useWizardData must be used within a WizardDataProvider');
  }
  return context as WizardDataContextValue<TData>;
};

/**
 * Higher-order component for easy wizard data provider setup
 */
export const withWizardData = <TData extends Record<string, unknown>>(
  Component: React.ComponentType,
  config: {
    initialData: TData;
    storageKey?: string;
    onDataChange?: (data: TData) => void;
  }
) => {
  return (props: Record<string, unknown>) => 
    React.createElement(
      WizardDataProvider as React.ComponentType<typeof config>,
      config,
      React.createElement(Component, props)
    );
};